import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Users, CalendarDays, FolderHeart, Presentation } from "lucide-react";
import { api, apiErr } from "../api";
import { BRAND } from "../brand";
import { PanelPage, Header, PageTitle } from "../ui";
import PatientsTab from "../tabs/PatientsTab";
import AgendaTab from "../tabs/AgendaTab";
import CasesTab from "../tabs/CasesTab";
import SlidesTab from "../tabs/SlidesTab";

const TABS = [
  { id: "pacientes", label: "Pacientes", icon: Users },
  { id: "agenda", label: "Agenda y citas", icon: CalendarDays },
  { id: "casos", label: "Casos clínicos", icon: FolderHeart },
  { id: "diapositivas", label: "Diapositivas", icon: Presentation },
];

export default function Dashboard() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.some((t) => t.id === params.get("tab")) ? params.get("tab") : "pacientes";
  const [patients, setPatients] = useState(null);

  const loadPatients = useCallback(async () => {
    try { const { data } = await api.get("/patients"); setPatients(data); }
    catch (e) { toast.error(apiErr(e, "No se pudieron cargar los pacientes")); setPatients((p) => p || []); }
  }, []);
  useEffect(() => { loadPatients(); }, [loadPatients]);

  return (
    <PanelPage>
      <Header wide />
      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-8">
        <PageTitle eyebrow="Panel clínico" title={BRAND.doctor} />
        <div role="tablist" className="flex gap-6 border-b pn-line mb-7 overflow-x-auto overflow-y-hidden pn-tabs">
          {TABS.map((t) => (
            <button key={t.id} role="tab" aria-selected={tab === t.id} className="pn-tab" onClick={() => setParams(t.id === "pacientes" ? {} : { tab: t.id })}>
              <t.icon size={16} /> {t.label}
            </button>
          ))}
        </div>
        {tab === "pacientes" && <PatientsTab patients={patients} reload={loadPatients} />}
        {tab === "agenda" && <AgendaTab patients={patients || []} reloadPatients={loadPatients} />}
        {tab === "casos" && <CasesTab patients={patients || []} />}
        {tab === "diapositivas" && <SlidesTab />}
      </main>
    </PanelPage>
  );
}
